import {
  useCreateBulkTicketSaleBatchMutation,
  useCreateBulkTicketSaleMutation,
  useGetAllTicketSaleTargetsQuery
} from 'Services/SalesManagement/Features/TicketSale/ticketSaleApi'

export function useBulkTicketSaleFormFunctions() {
  const { data: ticketSaleTargets, isFetching: isTicketSaleTargetsFetching } =
    useGetAllTicketSaleTargetsQuery({ disable_pagination: true })
  const [createBulkTicketSale, { isLoading: isCreateBulkTicketSaleLoading }] =
    useCreateBulkTicketSaleMutation()
  const [createBulkTicketSaleBatch, { isLoading: isCreateBulkTicketSaleBatchLoading }] =
    useCreateBulkTicketSaleBatchMutation()

  return {
    ticketSaleTargets,
    isTicketSaleTargetsFetching,
    createBulkTicketSale,
    isCreateBulkTicketSaleLoading,
    createBulkTicketSaleBatch,
    isCreateBulkTicketSaleBatchLoading
  }
}
